module.exports = __webpack_public_path__ + "img/form-settings-trash.2dba7594.svg";